import { render } from "./OpportunitiesView.vue?vue&type=template&id=89b7ce88"
import script from "./OpportunitiesView.vue?vue&type=script&lang=js"
export * from "./OpportunitiesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__